/* Polish quick-add modals opened from TOP product cards. */
(function() {
  var lastQuickAddCard = null;

  function compactText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function getCardSummary(card) {
    if (!card) return null;
    var titleEl = card.querySelector('.grid-product__title');
    var vendorEl = card.querySelector('.grid-product__vendor');
    var imageEl = card.querySelector('.grid-product__image, .image-element, img');
    var title = compactText(titleEl && titleEl.textContent);
    if (!title) return null;
    return {
      title: title,
      vendor: compactText(vendorEl && vendorEl.textContent),
      image: imageEl && (imageEl.currentSrc || imageEl.src)
    };
  }

  function buildSummary(summary) {
    var wrapper = document.createElement('div');
    wrapper.className = 'remente-quick-add-summary';
    if (summary.image) {
      var image = document.createElement('img');
      image.className = 'remente-quick-add-summary__image';
      image.src = summary.image;
      image.alt = summary.title;
      wrapper.appendChild(image);
    }
    var body = document.createElement('div');
    body.className = 'remente-quick-add-summary__body';
    if (summary.vendor) {
      var vendor = document.createElement('p');
      vendor.className = 'remente-quick-add-summary__vendor';
      vendor.textContent = summary.vendor;
      body.appendChild(vendor);
    }
    var title = document.createElement('p');
    title.className = 'remente-quick-add-summary__title';
    title.textContent = summary.title;
    body.appendChild(title);
    wrapper.appendChild(body);
    return wrapper;
  }

  function fillEmptyAddButton(container) {
    var buttons = container.querySelectorAll('.add-to-cart');
    buttons.forEach(function(button) {
      if (compactText(button.textContent)) return;
      var span = button.querySelector('span') || button;
      span.textContent = 'カートに追加';
    });
  }

  function enhanceQuickAddModal() {
    var tooltip = document.querySelector('tool-tip.quick-add-modal[data-tool-tip-open="true"]');
    if (!tooltip) return;
    var content = tooltip.querySelector('[data-tool-tip-content]');
    if (!content) return;

    fillEmptyAddButton(content);

    if (content.querySelector('.remente-quick-add-summary')) return;
    var summary = getCardSummary(lastQuickAddCard);
    if (!summary) return;

    var productContent = content.querySelector('.page-content--product') || content.firstElementChild || content;
    productContent.insertBefore(buildSummary(summary), productContent.firstChild);
  }

  document.addEventListener('tooltip:interact', function(event) {
    if (!event.detail || event.detail.context !== 'QuickAdd') return;
    lastQuickAddCard = event.target && event.target.closest && event.target.closest('.grid-product');
  }, true);

  document.addEventListener('tooltip:open', function(event) {
    if (!event.detail || event.detail.context !== 'QuickAdd') return;
    lastQuickAddCard = event.target && event.target.closest && event.target.closest('.grid-product');
    setTimeout(enhanceQuickAddModal, 0);
    setTimeout(enhanceQuickAddModal, 350);
    setTimeout(enhanceQuickAddModal, 900);
  }, true);

  document.addEventListener('quickshop:opened', function() {
    setTimeout(enhanceQuickAddModal, 0);
    setTimeout(enhanceQuickAddModal, 250);
  }, true);
})();
